import React from 'react';
import { Lock } from 'lucide-react';

type Props = {
  moduleLabel: string;
  moduleKey?: string;
};

/**
 * Shown when a tenant user opens a nav item whose platform module is not enabled.
 * Nav stays visible; access is granted only from Platform Admin → Modules.
 */
const ModuleNoAccess: React.FC<Props> = ({ moduleLabel, moduleKey }) => {
  return (
    <div className="hub-panel">
      <div className="hub-panel__inner flex flex-col items-center justify-center py-16 px-6 text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-500">
          <Lock size={28} strokeWidth={1.75} />
        </div>
        <h2 className="text-lg font-semibold text-slate-800 mb-1">No access</h2>
        <p className="text-sm text-slate-600 max-w-md">
          <strong>{moduleLabel}</strong> is not enabled for this organization.
          Ask your platform administrator to grant this module under Platform Admin → Clients → Modules.
        </p>
        {moduleKey ? (
          <p className="mt-3 text-xs text-slate-400 font-mono">module: {moduleKey}</p>
        ) : null}
      </div>
    </div>
  );
};

export default ModuleNoAccess;
